// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"four-stories-four-images-m__wrapper__2iB_Q","carousel-wrapper":"four-stories-four-images-m__carousel-wrapper__3TqEH"};